export interface AtlAccordionProps {
    alwaysOpen?: boolean;
}

export class AtlAccordionClickEvent extends CustomEvent<{ title: string, opened: boolean }> {
    static EVENT_NAME = 'atlantis-accordion-click';

    constructor(detail: { title: string, opened: boolean }) {
        super(AtlAccordionClickEvent.EVENT_NAME, { detail, bubbles: true, composed: true });
    }
}

export class AtlAccordionCollapseEvent extends CustomEvent<{ title: string }> {
    static EVENT_NAME = 'atlantis-accordion-collapse';

    constructor(detail: { title: string }) {
        super(AtlAccordionCollapseEvent.EVENT_NAME, { detail, bubbles: true, composed: true });
    }
}